import { useTranslation } from "react-i18next";
import { viewerTimeZone, viewerWallClock, type ViewerWallClock } from "@/lib/timezone";

/** Sarajevski termin + vrijeme posjetioca kad mu sat pokazuje nešto drugo. */
export function SessionTime({ dateStr, time }: { dateStr: string | null; time: string }) {
  const { t } = useTranslation();
  const hint = dateStr ? viewerWallClock(dateStr, time, viewerTimeZone()) : null;
  if (!hint) return <>{time}</>;
  const key =
    hint.dayOffset < 0 ? "booking.viewerTimePrevDay" : hint.dayOffset > 0 ? "booking.viewerTimeNextDay" : "booking.viewerTime";
  return (
    <>
      {time}{" "}
      <span className="font-normal text-muted-foreground">({t(key, { time: hint.time })})</span>
    </>
  );
}

export function formatViewerDiff(hint: ViewerWallClock, t: (key: string, opts?: Record<string, unknown>) => string): string {
  const abs = Math.abs(hint.diffMinutes);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  const amount = [h ? `${h} h` : "", m ? `${m} min` : ""].filter(Boolean).join(" ");
  return t(hint.diffMinutes < 0 ? "booking.viewerDiffBehind" : "booking.viewerDiffAhead", { amount });
}

/** Napomena iznad slotova, samo za posjetioca čiji sat odstupa od Sarajeva. */
export function SarajevoTimeNote({ dateStr, time }: { dateStr: string; time: string }) {
  const { t } = useTranslation();
  const hint = viewerWallClock(dateStr, time, viewerTimeZone());
  if (!hint) return null;
  return (
    <p data-testid="booking-sarajevo-time-note" className="rounded-xl bg-muted/40 px-3 py-2 text-[13px] text-muted-foreground">
      {t("booking.sarajevoTimeNote", { diff: formatViewerDiff(hint, t) })}
    </p>
  );
}
